import React from 'react';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="border-t border-line pt-[70px] pb-[40px]" data-id="element-48">
      <div className="max-w-wrap mx-auto px-7" data-id="element-49">
        <div className="grid grid-cols-1 md:grid-cols-[1.6fr_1fr_1fr] gap-[34px] md:gap-10 mb-[54px]" data-id="element-50">
          <div data-id="element-51">
            <div className="text-[1.5rem] font-bold tracking-[-0.02em] mb-4 flex items-center gap-[11px]" data-id="element-52">
              <span className="w-[11px] h-[11px] rounded-full bg-acid shadow-[0_0_14px_var(--acid)]" data-id="element-53"></span>
              LEADS AND WIN{' '}
              <span className="text-ink-faint font-medium text-[0.9rem]" data-id="element-54">
                SL
              </span>
            </div>
            <p className="text-ink-dim text-[0.94rem] max-w-[38ch]" data-id="element-55">
              Agencia de publicidad y marketing digital especializada en
              Facebook &amp; Instagram Ads. Convertimos inversión publicitaria
              en clientes reales.
            </p>
            <div className="mt-[22px]" data-id="element-56">
              <span className="inline-flex items-center gap-2 border border-line rounded-full py-[6px] px-[14px] text-[0.78rem] text-ink-dim" data-id="element-57">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#36e8c0" data-id="element-58">
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95Z" data-id="element-59" />
                </svg>
                Meta Business Partner mindset
              </span>
            </div>
          </div>

          <div data-id="element-60">
            <h5 className="text-[0.74rem] tracking-[0.14em] text-ink-faint uppercase font-mono mb-[18px]" data-id="element-61">
              Navegación
            </h5>
            <a href="#servicios" className="block text-ink-dim text-[0.94rem] mb-[11px] transition-colors hover:text-acid" data-id="element-62">
              Servicios
            </a>
            <a href="#metodo" className="block text-ink-dim text-[0.94rem] mb-[11px] transition-colors hover:text-acid" data-id="element-63">
              Método
            </a>
            <a href="#resultados" className="block text-ink-dim text-[0.94rem] mb-[11px] transition-colors hover:text-acid" data-id="element-64">
              Resultados
            </a>
            <a href="#porque" className="block text-ink-dim text-[0.94rem] mb-[11px] transition-colors hover:text-acid" data-id="element-65">
              Por qué nosotros
            </a>
            <a href="#contacto" className="block text-ink-dim text-[0.94rem] mb-[11px] transition-colors hover:text-acid" data-id="element-66">
              Contacto
            </a>
          </div>

          <div data-id="element-67">
            <h5 className="text-[0.74rem] tracking-[0.14em] text-ink-faint uppercase font-mono mb-[18px]" data-id="element-68">
              Datos de la empresa
            </h5>
            <p className="block text-ink-dim text-[0.94rem] mb-[11px]" data-id="element-69">
              LEADS AND WIN SL
            </p>
            <p className="block text-ink-dim text-[0.94rem] mb-[11px]" data-id="element-70">
              NIF · B01771732
            </p>
            <p className="block text-ink-dim text-[0.94rem] mb-[11px]" data-id="element-71">
              Calle Santjoanistes 1P 3 PTA 3<br data-id="element-72" />
              08006 Barcelona, España
            </p>
            <p className="block text-ink-dim text-[0.94rem] mb-[11px]" data-id="element-73">
              CNAE 7311 · Agencias de publicidad
            </p>
          </div>
        </div>

        <div className="border-t border-line pt-[28px] flex justify-between flex-wrap gap-[14px] text-ink-faint text-[0.82rem]" data-id="element-74">
          <span data-id="element-75">
            © {year} LEADS AND WIN SL · Todos los derechos reservados.
          </span>
          <span className="font-mono" data-id="element-76">
            Diseñado para convertir · Barcelona 🇪🇸
          </span>
        </div>
      </div>
    </footer>;
}